import React, { Component } from "react";
import RadioGroup from "./RadioGroup";
import "./HabitScorecard.css";

class HabitScorecard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: "",
      items: []
    };
  }

  onChange = event => {
    this.setState({ term: event.target.value });
  };

  onSubmit = event => {
    event.preventDefault();
    if (
      this.state.term != "" &&
      this.state.items.indexOf(this.state.term) == -1
    ) {
      this.setState(prevState => ({
        items: [...prevState.items, this.state.term]
      }));
    }
    this.setState({
      term: ""
    });
  };

  removeItem = event => {
    let remItem = event.currentTarget.dataset.val;
    this.setState(prevState => ({
      items: prevState.items.filter(item => item !== remItem)
    }));
  };

  removeAll = event => {
    this.setState({ items: [] });
  };

  renderList = () => {
    return (
      <ul className="list-group list-group-flush">
        {this.state.items.map((item, index) => (
          <li className="list-group-item text-white bg-dark" key={index}>
            <div className="container">
              <div className="row">
                <div className="itemTitle col-6">{item}</div>
                <RadioGroup />
                <div className="removeButtonContainer col-2">
                  <a
                    className="removeButton"
                    onClick={this.removeItem}
                    data-val={item}
                  >
                    x
                  </a>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-lg-4" />
          <div className="col-sm-12 col-lg-4">
            <div className="card cardCustom text-white bg-dark">
              <div class="card-header">
                <form onSubmit={this.onSubmit}>
                  <input
                    class="form-control"
                    placeholder="Add Habit"
                    value={this.state.term}
                    onChange={this.onChange}
                  />
                </form>
              </div>
              {this.state.items.length != 0 ? (
                this.renderList()
              ) : (
                <p class="card-text text-center text-muted cardBody">
                  For more info on building good habits
                  <br /> and breaking the bad ones checkout <br />{" "}
                  <a href="http://atomichabits.com">Atomic Habits</a>
                  &nbsp; by James Clear.
                </p>
              )}
              <div class="card-footer text-muted">
                Created By &nbsp;
                <a href="#" className="card-link">
                  Fraser Hamilton
                </a>
                <a
                  href="#"
                  className="card-link"
                  onClick={this.removeAll}
                  Style="padding-left: 2em;"
                >
                  Clear All
                </a>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-lg-4" />
        </div>
      </div>
    );
  }
}

export default HabitScorecard;
